/**
 * Created by Administrador on 17/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('ssr', {
                parent: 'app',
                url: '/ssr?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/ssr/settingSsr/ssr/ssrs.html',
                        controller: 'ssrCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassificationsSsr('ssr'); // default selected
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['ssr','subClassificationSsr', 'classificationSsr']);
                            }],
                            items: ['ssrService', '$stateParams', function (ssrService, $stateParams) {
                             return ssrService.getSsrs($stateParams.page, $stateParams.size);
                             }]
                        }
                    }
                }
            })
            .state('ssrEdit', {
                parent: 'app',
                url: '/ssr/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/ssr/settingSsr/ssr/editSsr.html',
                        controller: 'newEditSsrCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassificationsSsr('ssr'); // default selected
                            }],
                            item: ['ssrService', '$stateParams', function (ssrService, $stateParams) {
                             return ssrService.getSsr($stateParams.id,true)
                             }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['ssr']);
                            }],
                            action: [function() {
                                return "edit";
                            }],
                            classifications: ['classificationSsrService', function (classificationSsrService) {
                                return classificationSsrService.getClassificationListSsr();
                            }]
                        }
                    }
                }
            })
    }
})();
